import React from 'react'
import { FaPhone, FaPrint } from 'react-icons/fa'

import glsLink from '../images/gls_link.png'

const SedeGls = ({ sede }) => {
  return (
    <>
      <div className="flex items-center justify-start mb-4">
        <img src={glsLink} alt="gls-link" className="mr-3 w-auto h-full" />
        <h2 className="text-xl text-gls-blue-700">GLS {sede.nomeSede}</h2>
      </div>
      <div className="ml-3 pl-8 border-l-4 border-blue-200 text-sm">
        {sede.indirizzo}
        <br />
        {sede.cap} {sede.citta} ({sede.provincia})
        <div className="mt-3 mb-3 text-gray-600">
          <div className="flex items-center">
            <FaPhone className="inline mr-2 text-gray-400" />
            {sede.tel}
          </div>
          <div className="flex items-center">
            <FaPrint className="inline mr-2 text-gray-400" />
            {sede.fax}
          </div>
        </div>
        <a
          href={`mailto:${sede.email}`}
          target="_blank"
          rel="noreferrer"
          className="text-gls-blue-600 hover:text-gls-blue-900 hover:underline"
        >
          {sede.email}
        </a>
      </div>
    </>
  )
}

export default SedeGls
